import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NotesComponent } from 'src/app/components/notes/notes.component';
import { TransactionHistoryComponent } from 'src/app/components/transaction-history/transaction-history';
import { ServiceRequestType } from 'src/app/models/service-request-type';
import { ServiceRequest } from 'src/app/models/service.request';
import { AgenciesService } from 'src/app/services/agencies.service';
import { AuthService } from 'src/app/services/authservice/auth.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import { Settings } from 'src/app/services/settings';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { UserService } from 'src/app/services/user.service';
import { PastAssistanceComponent } from '../../drawer/pastassistance/pastassistance.component';
import { dataRecord, GlobalSearchComponent } from '../../globalsearch/globalsearch.component';
import { CaseDetailsComponent } from '../../../common-tabs/case-details/case-details.component';
import { CasesService } from 'src/app/services/cases.service';
import { ServiceRequestMemberHistory } from 'src/app/models/service-request-member-history';

import { MembersComponent } from '../../../common-tabs/members/members.component';
import { RequestSummaryTabComponent } from '../../tabs/request-summary-tab/request-summary-tab.component';
import { MailMessagesComponent } from "../../drawer/mailmessages/mailmessages.component";

import { QualificationResponsesComponent } from '../../../common-tabs/qualification-responses/qualification-responses.component';
import { AddNewRequestCompactComponent } from "../add-new-request-compact/add-new-request-compact.component";
import { CaseRequestsListComponent } from "../../../common-tabs/case-requests-list/case-requests-list.component";
import { Case } from "../../../../models/case";
import { CaseDocumentsComponent } from "../../../common-tabs/case-documents/case-documents.component";
import { DwUtils } from 'src/app/components/utils/dw-utils';
import {
	CaseavatarpreviewComponent
} from "../../../common-tabs/case-documents/dialogs/caseavatarpreview/caseavatarpreview.component";


@Component({
	selector: 'app-requestdetails',
	templateUrl: './requestdetails.component.html',
	styleUrls: ['./requestdetails.component.css']
})
export class RequestdetailsComponent {

	selectedRecord: ServiceRequest;
	public propContainerState: boolean | null = false;  /** set to false ***/
	public visiblePropertiesTab: boolean | null = true;
	public serviceRequestTypes: ServiceRequestType[];
	public membersList: any;
	public advocateFlag: boolean = false;
	public advocate: any;

	showHouseholdTab = false;
	public selectedCaseId = 0;
	public selectedDrawTabLabel = '';
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabLabel = 'Request';
	public id: any | null = '';
	public description: any | null = '';
	public activeStatus: any | null = '';
	public busyCursor: boolean | null = false;

	public showDrawer: boolean = false;
	public showList: Array<dataRecord>;
	public showStatusList: Array<dataRecord>;

	public strCaseNumber = '';
	public strRequest = '';
	public strDaysLeft = '';
	public strApplicant = '';
	public strRequestDate = '';
	public strDaysLapsed = '';

	public placeHolderURL: string = '/assets/profile-img-generic.png';
	public selectedFile: any;
	public valFilePath: any;
	public base64textStringAvatar: string;
	public loading = false;
	public imageAvatarFlag = false;
	public avatarURL = '';
	public visiblePreviewCaseAvatarDialog = false;
	public primaryAgencyFlag: boolean = false;
	visibleEdit = false;

	showCasesTab = false;
	showMembersTab = false;
	showDocumentsTab = false;
	showCaseRequestsTab = false;
	showActivityTab = false;
	showQualificationsTab = false;

	showNotesTab = false;
	showEmailsTab = false;
	showPastAssistanceTab = false;

	/*** Drawer Children ***/
	@ViewChild('pastAssistance', { static: false }) pastAssistance: PastAssistanceComponent;
	@ViewChild('notes', { static: false }) notes: NotesComponent;
	@ViewChild('mailMessages', { static: false }) mailMessages: MailMessagesComponent;

	/*** New Service Request Dialog ***/
	@ViewChild('newRequest', { static: true }) newRequest: AddNewRequestCompactComponent;

	@ViewChild('history', { static: false }) history: TransactionHistoryComponent;
	@ViewChild('casedetails', { static: false }) casedetails: CaseDetailsComponent;
	@ViewChild('members', { static: false }) members: MembersComponent;
	@ViewChild('casedocuments', { static: false }) casedocuments: CaseDocumentsComponent;
	@ViewChild('requestSummaryTab', { static: false }) requestSumamryTab: RequestSummaryTabComponent;
	@ViewChild('requests', { static: false }) requests: CaseRequestsListComponent;
	@ViewChild('qualifications', { static: false }) qualifications: QualificationResponsesComponent;
	@ViewChild('previewCaseAvatar', { static: true }) previewCaseAvatar: CaseavatarpreviewComponent;

	@Input() set selectedServiceRequest(value: ServiceRequest) {
		this.selectedRecord = value;
		this.onShowHandler(value);
	}

	@Output() editEvent = new EventEmitter<any>();

	constructor(public serviceRequestsService: ServiceRequestsService, private txService: TransactionHistoryService,
		public agenciesService: AgenciesService, private serviceDefService: ServiceDefService, private authService: AuthService,
		private userService: UserService, private casesService: CasesService) {
		this.selectedRecord = new ServiceRequest();
		//this.selectedDrawTabLabel = 'Past Assistance';
		this.showDrawer = true;
	}

	public ngOnInit() {
		if (Settings.getInstance().hasPrivilege('REQUEST_DETAIL_EDIT', "SHOW")) {
			this.visibleEdit = false;
		} else {
			this.visibleEdit = true;
		}
		this.showDocumentsTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS', "SHOW");
		this.showActivityTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_ACTIVITY', "SHOW");
		this.showCaseRequestsTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE_REQUESTS', "SHOW");
		this.showQualificationsTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_QUALIFICATIONS', "SHOW");
		this.showMembersTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS', "SHOW");
		this.showCasesTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE', "SHOW");

		this.showPastAssistanceTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_PAST_ASSISTANCE', "SHOW");
		this.showNotesTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES', "SHOW");
		this.showEmailsTab = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_EMAILS', "SHOW");
		if (this.showPastAssistanceTab) {
			this.selectedDrawTabLabel = 'Past Assistance';
		} else if (this.showNotesTab) {
			this.selectedDrawTabLabel = 'Notes';
		} else if (this.showEmailsTab) {
			this.selectedDrawTabLabel = 'Emails';
		}

	}

	public onShowHandler(record: ServiceRequest) {
		if (!record) {
			return;
		}
		this.selectedRecord = record;
		this.serviceRequestTypes = Settings.getInstance().serviceRequestTypesList;
		this.primaryAgencyFlag = Settings.getInstance().isPrimaryAgency(this.selectedRecord.agencyId);
		if (this.selectedRecord.caseId > 0) {
			this.serviceRequestsService.getCaseById(this.selectedRecord.caseId).subscribe(
				(result) => {
					if(this.requests){
						this.requests._caseRecord = result;
					}
					this.queryRecords();
				},
				(error) => {
					Settings.getInstance().handleError(error, 'fetching Case');
				});
		} else {
			this.queryRecords();
		}
	}
	queryRecords() {

		if (this.selectedRecord.caseId > 0) {
			this.queryMemberRecords();

		}
		else {
			this.displayDetail(this.selectedRecord);
			this.doLoadAvatarImage();
		}
	}
	public queryMemberRecords(): void {
		if (!this.selectedRecord || !this.selectedRecord.caseId || this.selectedRecord.caseId < 1) {
			return;
		}
		this.membersList = [];
		this.advocateFlag = false;
		this.advocate = null;

		const isHistoryMode = this.selectedRecord.clericalOpen === 1 || this.selectedRecord.recordStatus === 0;
		if (isHistoryMode) {
			this.casesService.getMemberHistory(this.selectedRecord.id).subscribe(
				(histRecords: ServiceRequestMemberHistory[]) => {
					this.applyHistoryRecords(histRecords);
				},
				(error) => {
					Settings.getInstance().handleError(error, 'fetching Member History');
					this.applyHistoryRecords([]);
				}
			);
			return;
		}

		this.serviceRequestsService.getHouseholdMembersByCaseId(this.selectedRecord.caseId).subscribe(
			(results) => {
				this.membersList = results;
				const advIdx = this.membersList.findIndex(s => s.relationship === 'Advocate');
				if (advIdx > -1) {
					this.advocateFlag = true;
					this.advocate = this.membersList[advIdx];
				}
				const selfMember = this.membersList.find(s => s.relationship === 'Self');
				if (selfMember) {
					this.selectedRecord.caseName = DwUtils.returnFullName(selfMember.firstName, selfMember.middleName, selfMember.lastName);
				}
				this.displayDetail(this.selectedRecord);
				this.doLoadAvatarImage();
				if (this.casedetails && this.selectedCaseId > 0) {
					this.casedetails.onShowHandler(this.selectedCaseId, this.selectedRecord, this.advocate);
				}
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching Members');
			});
	}

	/** Apply a set of history records to the view — shared between first-load and on-demand snapshot paths */
	private applyHistoryRecords(histRecords: ServiceRequestMemberHistory[]): void {
		this.membersList = histRecords.filter(h => !ServiceRequestMemberHistory.isContactOnlyAdvocate(h));
		const advRec = histRecords.find(h => h.relationship === 'Advocate' && !ServiceRequestMemberHistory.isContactOnlyAdvocate(h));
		if (advRec) {
			this.advocateFlag = true;
			this.advocate = advRec;
		}
		const selfMember = histRecords.find(h => h.relationship === 'Self');
		if (selfMember) {
			this.selectedRecord.caseName = DwUtils.returnFullName(selfMember.firstName, selfMember.middleName, selfMember.lastName);
		}
		this.displayDetail(this.selectedRecord);
		this.doLoadAvatarImage();
		if (this.casedetails && this.selectedCaseId > 0) {
			this.casedetails.onShowHandler(this.selectedCaseId, this.selectedRecord, this.advocate);
		}
	}

	public onPropertiesToggle() {
		this.propContainerState = !this.propContainerState;
		/** if the drawer is open - then select the data for the selected record if chosen **/
		if ((this.propContainerState === true) && (this.selectedCaseId > 0)) {
			this.displayDrawerData();
		}
	}
	public doDrawerTabChange(event: any): void {

		const tabLabel = event.tab.textLabel;
		this.selectedDrawTabLabel = tabLabel;
		this.displayDrawerData();

	}
	public displayDrawerData(): void {

		switch (this.selectedDrawTabLabel) {
			case 'Past Assistance':
				if (this.pastAssistance === undefined) {
					return;
				}
				this.pastAssistance.onShowHandler(this.selectedCaseId);
				break;
			case 'Notes':
				this.notes.parentId = this.selectedRecord.caseId;
				this.notes.onShowHandler();
				break;
			case 'Email':
				this.mailMessages.onShowHandler();
				break;
		}
	}
	public doTabChange(event): void {
		const tabLabel = event.tab.textLabel;
		this.selectedTabLabel = tabLabel;
		if (this.selectedRecord) {
			this.displayDetail(this.selectedRecord);
		}
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}

	public displayDetail(record: ServiceRequest) {
		if (record === undefined) {
			return;
		}
		this.strCaseNumber = record.caseNumber || '';
		this.strApplicant = record.caseName || '';
		this.strRequest = record.serviceRequestDesc || '';
		this.strCaseNumber = record.caseNumber || '';
		this.strDaysLapsed = record.daysLapsed !== undefined && record.daysLapsed !== null ? record.daysLapsed + '' : '';
		this.strDaysLeft = record.daysLeft !== undefined && record.daysLeft !== null ? record.daysLeft + '' : '';

		this.id = record.id;

		this.selectedCaseId = this.selectedRecord.caseId;
		/** individual tabs  .... */
		if (this.selectedTabLabel === 'Activity') {
			this.history.onShowHandler('ServiceRequests', 'id', record.id.toString(), this.selectedRecord.caseId.toString());
		}
		/** Case Details **/
		setTimeout(() => {
			switch (this.selectedTabLabel) {
				case 'Request':
					/** Request Summary **/
					this.requestSumamryTab.onShowHandler(this.selectedCaseId, this.selectedRecord);
					break;
				case 'Case':
					/** case details **/
					this.casedetails.onShowHandler(this.selectedCaseId, this.selectedRecord, this.advocate);
					break;
				case 'Members':
					/** members **/
					this.members.onShowHandler(this.selectedCaseId, this.selectedRecord);
					break;
				case 'Documents':
					/** case documents **/
					this.casedocuments.onShowHandler(this.selectedCaseId, this.selectedRecord);
					break;
				case 'Qualifications':
					/** qualifications **/
					this.qualifications.onShowHandler(this.selectedRecord, this.selectedRecord.caseId);
					break;
				case 'Case Requests':
					/** Related Requests **/
					const cs = new Case();
					cs.id = this.selectedRecord.caseId;
					cs.caseNumber = this.selectedRecord.caseNumber;
					cs.firstName = this.selectedRecord.caseName;
					this.requests.onShowHandler(cs);
					break;
				default:
					break;
			}
		}, 0);
		/** drawer (if it is open) **/
		if (this.propContainerState === true) {
			this.displayDrawerData();
		}
	}
	public getBackgroundColor(record: ServiceRequest): string {
		if (!record) {
			return;
		}
		if (record.daysLeft >= 3) {
			return '#29db69'; // Green background for days lapsed less than or equal to 0
		} else if (record.daysLeft <= 0) {
			return '#ff6c6c'; // Red background for days lapsed more than 7
		} else {
			return '#ffbf6c'; // Orange background for days lapsed between 1 and 7
		}
	}
	public doLoadAvatarImage() {
		this.imageAvatarFlag = false;
		if (!this.selectedRecord || !this.selectedRecord.caseId || this.selectedRecord.caseId < 1) {
			return;
		}
		this.serviceRequestsService.getCaseAvatarImage(this.selectedRecord.caseId).subscribe(
			(data1) => {
				const tempImagePath: string = URL.createObjectURL(data1);
				this.avatarURL = 'url(' + tempImagePath + ')';
				document.getElementById('avatar').style.backgroundImage = this.avatarURL;
				this.imageAvatarFlag = true;
			},
			(error1) => {
				this.imageAvatarFlag = false;
				this.avatarURL = 'url(' + this.placeHolderURL + ')';
				document.getElementById('avatar').style.backgroundImage = this.avatarURL;
			}
		);
	}
	public showCaseAvatarPreview() {

		this.visiblePreviewCaseAvatarDialog = true;
		this.previewCaseAvatar.onShowHandler(this.selectedRecord.caseId);
	}
	public hideCaseAvatarPreview() {
		this.visiblePreviewCaseAvatarDialog = false;
	}
	public doReloadMembers(): void {
		this.queryMemberRecords();
	}
	/** Called after a Case tab save (incl. clerical-reopen history save) so the
	 * modal header and the Members history table reflect the change immediately,
	 * without waiting for a tab switch or manual screen refresh. */
	public onCaseDetailsSaved(): void {
		if (this.selectedRecord) {
			this.strApplicant = this.selectedRecord.caseName || '';
			this.strCaseNumber = this.selectedRecord.caseNumber || '';
			this.strRequest = this.selectedRecord.serviceRequestDesc || '';
		}
		this.doReloadMembers();
	}
}
